<!-- src/components/Sidebar.vue -->
<template>
  <div class="leftside-menu">
    <router-link to="/installation-list" class="logo logo-light">
      <span class="logo-lg">
        <img :src="`${$logoDir}logo.png`" alt="logo" />
      </span>
      <span class="logo-sm">
        <img :src="`${$logoDir}logo-sm.png`" alt="small logo" />
      </span>
    </router-link>

    <div class="h-100" id="leftside-menu-container" data-simplebar>
      <div class="simplebar-wrapper">
        <div class="simplebar-mask">
          <div class="simplebar-offset">
            <div class="simplebar-content-wrapper" role="region" style="height: 100%; overflow: scroll hidden;">
              <div class="simplebar-content" style="padding: 0px;">
                <ul class="side-nav">
                  <li :class="['side-nav-item', {'menuitem-active': activeMenu === 'installations'}]">
                    <router-link to="/installation-list" class="side-nav-link">
                      <i class="uil-home"></i>
                      <span>{{ $t('nav.installations') }}</span>
                    </router-link>
                  </li>

                  <li v-if="has_team" :class="['side-nav-item', {'menuitem-active': activeMenu === 'myteam'}]">
                    <router-link to="/members" class="side-nav-link">
                      <i class="ri-team-line"></i>
                      <span>{{ $t('nav.myTeam') }}</span>
                    </router-link>
                  </li>

                  <li :class="['side-nav-item', {'menuitem-active': activeMenu === 'interventions'}]">
                    <router-link to="/interventions" class="side-nav-link">
                      <i class="uil-wrench"></i>
                      <span>Mes interventions</span>
                    </router-link>
                  </li>

                  <li :class="['side-nav-item', {'menuitem-active': activeMenu === 'account'}]">
                    <router-link to="/account" class="side-nav-link">
                      <i class="uil-user"></i>
                      <span>{{ $t('nav.account') }}</span>
                    </router-link>
                  </li>

                  <li class="side-nav-item">
                    <router-link to="/logout" class="side-nav-link">
                      <i class="uil-exit"></i>
                      <span>{{ $t('nav.logout') }}</span>
                    </router-link>
                  </li>
                </ul>


              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useUserStore } from '@/stores/userStore';
import { useRoute } from 'vue-router';
import { onMounted, ref, watch } from 'vue';
export default {
  name: "SideBar",
  components: {},
  setup() {
    const userStore = useUserStore();
    const route = useRoute();
    const activeMenu = ref(null);
    const has_team = ref(process.env.VUE_APP_IS_ON_PREMISE === 'false' && userStore.installer.group_admin);

    const updateActiveMenu = () => {
      activeMenu.value = getActiveMenu();
    };

    function getActiveMenu() {
      if(route.path.includes('account')) {
        return "account";
      }
      if(route.path.includes('interventions')) {
        return "interventions";
      }
      if(route.path.includes('member')) {
        return "myteam";
      }
      return "installations";
    }

    onMounted(() => {
      updateActiveMenu();
    });

    watch(() => route.path, updateActiveMenu);

    return {
      activeMenu,
      has_team,
    }
  },
};
</script>
